import React from 'react';
//import userLogo from 'assets/images/user.png';
import dataservice from 'utils/dataservice';
// import SideMenu  from 'react-sidemenu'; 
//import 'assets/css/react-sidemenu.css'; 
import { translate, hasPageAccess, getUpdatedPageUrl, gotoUrl, isPageEnabled } from 'utils/common';
import { TOGGLE_LEFTMENU, MENU_CLICKED, PATH_CHANGED, CONFIRM_MENU_CLICK, LEFT_MENU_COLLAPSE_TIMEOUT, F_KEY, ADD_EDIT_PRODUCTS, PUBLIC_PATH } from 'utils/constants';
import ScrollArea from 'react-scrollbar';
import { Collapse } from 'reactstrap';
import classNames from 'classnames/bind';
class Card extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: null,
            collapse: this.getIsActiveItemExists()
        };
        this.handleClick = this.handleClick.bind(this);
        this.getIsActiveItemExists = this.getIsActiveItemExists.bind(this);
        this.isActive = this.isActive.bind(this);
        this.collapseAction = this.collapseAction.bind(this);

        /*         let ev = {};
                ev['LEFTMENU_COLLAPSE_ACTION'] = this.collapseAction;
                app.events.subscribe(ev, this); */

    }

    static getDerivedStateFromProps(props, state) {
        return {
            ...props
        }
    }

    getIsActiveItemExists() {
        let { item, activeLeftMenu } = this.props;
        if (item.children) {
            var activeitem = item.children.filter(menuItem => {
                return activeLeftMenu === menuItem.value
            })
            if (activeitem.length) return true;
        }
        return false
    }
    handleClick(menuitemdata) {
        // console.log('menuData ------'+menudata);
        if (menuitemdata) {
            if (app.history.location.pathname.includes(ADD_EDIT_PRODUCTS)) {
                ///If opened page is addeditproduct, check for changes
                app.events.trigger(CONFIRM_MENU_CLICK, menuitemdata);
            } else {
                app.events.trigger(MENU_CLICKED, menuitemdata);
            }
        } else {
            ////Submenu exists. Hence expand menu
            const { collapse, horizontalExpand } = this.state;
            this.setState({ collapse: !collapse }, () => {
                // if left menu minified, expand it
                if (!horizontalExpand) {
                    app.events.trigger('TOGGLE_HORIZONTAL_EXPAND');
                }
            });
        }
    }

    isActive(menuItem) {
        let { activeLeftMenu } = this.props;
        if (!menuItem.children) {
            if (menuItem.value && Array.isArray(menuItem.value) && menuItem.value.length) {
                return menuItem.value.includes(activeLeftMenu);
            }
            if (menuItem.value && typeof menuItem.value === 'string') {
                return activeLeftMenu === menuItem.value;
            }
        } else return this.getIsActiveItemExists()
        // return false;
    }

    collapseAction() {
        this.setState({ collapse: false });
    }
    chkShowOnFunction(menuvalue){
        if(menuvalue == 'scheduleexport'){
            return false
        } 
        return false;
    }

    render() {
        const { item, collapse } = this.state;
        var clsnames = classNames({
            'submenu': item.children && item.children.length,
            'open': collapse
        })
        ////Hiding left menu items based on privilage condition
        if( (!item.children && item.resourceCode && !hasPageAccess(item.resourceCode))
            || (item.children && item.children.length 
                && item.children.filter(childItem=> (!childItem.resourceCode 
                                                    || (childItem.resourceCode && hasPageAccess(childItem.resourceCode)))).length ==0)){
                                                        return <React.Fragment/>;
        }
        return (      
            <React.Fragment> 
               {/* TODO Chk privilage also */}
                {item.showOnFunction && !this.chkShowOnFunction(item.value)
                    &&  <React.Fragment></React.Fragment>}

                {(!item.showOnFunction || (item.showOnFunction && this.chkShowOnFunction(item.value))) 
                    && <div className={"card " + clsnames}>
                            {/* {(!item.resourceCode || (item.resourceCode && hasPageAccess(item.resourceCode)))  */}
                            <div className="card-header" onClick={(e) => this.handleClick(item.children ? null : { id: (Array.isArray(item.value) ? item.value[0] : item.value) })}>
                                {/* <div className="card-header" onClick={(e) => this.handleClick({id:(Array.isArray(item.value)?item.value[0]:item.value), label:item.label})}> */}
                                <h5 className={"mb-0 " + (this.isActive(item) ? 'active' : '')}>
                                    <button className={'btn btn-link btn-block '} type="button" >
                                        <i className={item.icon}></i>
                                        <span>{translate(item.label)}</span>
                                    </button>
                                </h5>
                            </div> 
            
                            {item.children &&
                                // <div className="collapse show"  > 
                                <Collapse isOpen={collapse}>
                                    <div className="card-body">
                                        <ul>
                                            {item.children.map((childItem, i) => {
                                                return <li key={'menu-' + childItem.label} onClick={(e) => this.handleClick({ id: childItem.value, label: childItem.label })}>
                                                    {(!childItem.resourceCode || (childItem.resourceCode && hasPageAccess(childItem.resourceCode)))
                                                        && (!childItem.showOnFunction || (childItem.showOnFunction && this.chkShowOnFunction(childItem.value))) 
                                                        && <a className={(this.props.activeLeftMenu == childItem.value) ? 'active' : ''}>
                                                                <i className={childItem.icon}></i>
                                                                {translate(childItem.label)}
                                                        </a>}
                                                </li>
                                            })}
                                        </ul>
                                    </div>
                                </Collapse>
                            }
                        </div>
                }
            </React.Fragment>  
            
        )
    }
}
class LeftPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: null,
            activeLeftMenu: "",
            open: false,
            horizontalExpand: true,
        };
        this.iconEnvMap = {
            'icon-baht': {
                TH: 'icon-baht',
                PH: 'icon-peso',
                ID: 'icon-rupiah'
            }
        };
        this.handlePathChange = this.handlePathChange.bind(this);
        this.toggleLeftMenu = this.toggleLeftMenu.bind(this);
        this.toggleHorizontalExpand = this.toggleHorizontalExpand.bind(this);
        this.autoCollapse = this.autoCollapse.bind(this);
        // this.handleClick = this.handleClick.bind(this);        
        const ev = {};
        ev[PATH_CHANGED] = this.handlePathChange;
        ev[TOGGLE_LEFTMENU] = this.toggleLeftMenu;
        ev['TOGGLE_HORIZONTAL_EXPAND'] = this.toggleHorizontalExpand;
        app.events.subscribe(ev);
        this.collapseTimer = null;
    }
    componentDidMount() {
        let menuFileName = 'navmenus.json';
        // if (app.userAuth.isAdmin) menuFileName = 'navmenus-admin.json'; 
        let portalmenujsonurl = location.protocol + '//' +location.host+PUBLIC_PATH+'data/'+menuFileName;
        dataservice.getRequest(portalmenujsonurl, {skipappendbaseurl:true, cache:true}).then(data=> {
            this.setState({...data});
        })
    }
    // processData(data){        
    //     data.items.map((item, i)=> {
    //         item.label = translate(item.label);
    //         item.children && item.children.map((subitem)=>{
    //             subitem.label = translate(subitem.label);
    //         })
    //      })
    //      return data;
    // }
    // handleClick(menuid){
    //     let menudata= {id: menuid}
    //     app.events.trigger(MENU_CLICKED, menudata);
    // }
    handlePathChange([route]) {
        var splitArr = route["componentId"].split('/');
        this.setState({ activeLeftMenu: route.name, open: false });
        // this.setState({ activeLeftMenu: splitArr[splitArr.length - 1], open: false });
    }

    autoCollapse(timeInSeconds) {
        clearTimeout(this.collapseTimer);
        if (this.state.horizontalExpand) {
            this.collapseTimer = setTimeout(() => {
                this.toggleHorizontalExpand();
            }, timeInSeconds * 1000);
        }
    }

    toggleHorizontalExpand() {
        this.setState({ horizontalExpand: !this.state.horizontalExpand }, () => {
            this.autoCollapse(LEFT_MENU_COLLAPSE_TIMEOUT);
            if (!this.state.horizontalExpand) {
                // app.events.trigger('LEFTMENU_COLLAPSE_ACTION');
                const refs = this.refs;
                this.state.items.map((v, i) => {
                    refs['card' + i].collapseAction();
                })
            }
        });

    }

    toggleLeftMenu(params) {
        this.setState({ open: !this.state.open });
    }
    render() {
        const { horizontalExpand } = this.state;
        return (
            <React.Fragment>
                <aside 
                // onMouseEnter={()=>console.log('enter')} onMouseLeave={()=>console.log('left')} 
                className={"left-navpanel navbar-collapse offcanvas-collapse " + (this.state.open ? 'open ' : '') + (!horizontalExpand ? ' minified ' : '')}>

                    {/* Minified Nav - hiding for now */}
                    <a className="minified-nav box-shadow" onClick={this.toggleHorizontalExpand}>
                        {
                            horizontalExpand &&
                            <i className="fas fa-chevron-left"></i>
                        }
                        {
                            !horizontalExpand &&
                            <i className="fas fa-chevron-right"></i>
                        }
                    </a>
                    {/* <h1 className="user-info">
                    <img className="user-img rounded-circle" src={userLogo}/>
                    <label>
                        {translate("welcome")}, <a className="user" onClick={()=>gotoUrl(resolveRouterPath(USER_PROFILE,{}))}>
                        {app.userAuth && app.userAuth.username}</a>
                        <a className="logoff"onClick={()=> app.events.trigger(USER_SIGN_OUT)}>{translate("signout")}</a>
                    </label>
                </h1> */}

                    <div className="pad custom-scroller">
                        <ScrollArea style={{ maxHeight: window.innerHeight - 148 }}
                            speed={0.8}
                            className="area"
                            contentClassName="content"
                            horizontal={false} >
                            <div className="accordion" >
                                {this.state.items && this.state.items.map((item, i) => {
                                    return <Card ref={'card' + i} activeLeftMenu={this.state.activeLeftMenu} key={'menucard-' + i} item={item} horizontalExpand={horizontalExpand} />
                                })}
                            </div>
                        </ScrollArea>

                        {/* <p className="scroll-down"><i className="fas fa-caret-down"></i></p> */}
                        {/*<div className="copyright">
                            <span><i className="far fa-copyright"></i> <label className="m-0">2020 NocNoc.</label></span>
                        </div>*/}
                    </div>
                    {/* <div className="pad5">
                    {this.state.items && <SideMenu items={this.state.items} onMenuItemClick={this.handleClick} />}
                    </div> */}
                </aside>
            </React.Fragment>
        )
    }
}

export default LeftPanel;
